export const layoutStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};
